<div class="c-advance-search__content">
  <div class="c-advance-search__form">
    <div class="c-dp-search">
      <div class="c-dp-search__block c-dp-search__block--hotel is-selected">
        <div class="c-dp-search__form c-dp-search__form--generic">
          <div class="c-dp-search__form-item">
            <surf-type-ahead
              [label]="'Country*'"
              [dataList]="countries"
              [selectedItem]="
                typeAheadService.getTypeAheadByType('country').selected
              "
              [mappings]="['code', 'value']"
              [sortOrder]="'A2Z'"
              [paramName]="'ontotext'"
              [placeholder]="
                typeAheadService.getTypeAheadByType('country').placeholderText
              "
              [bindFocusOut]="false"
              [selectAllOnEnter]="false"
              [minQueryLengthToProceed]="2"
              [isOnto]="false"
              [autoFocus]="true"
              [showErrorMsg]="true"
              [error]="false"
              (returnedQuery)="returnedSearchQueryForType($event, 'country')"
              (returnedData)="returnedValues($event, 'country')"
              (onClickOutside)="onClickOutside('country')"
              [tabIndex]="1"
            >
              <surf-type-ahead-content
                [typeAheadData]="
                  typeAheadService.getTypeAheadByType('country')?.filteredList
                "
                [available]="
                  typeAheadService.getTypeAheadByType('country')?.filteredList
                    .length > 0
                "
                (setItem)="selectCountry($event, 'country')"
              >
                <surf-type-ahead-item
                  *ngFor="
                    let item of typeAheadService.getTypeAheadByType('country')
                      .filteredList;
                    let i = index
                  "
                  (click)="selectCountry(item, 'country')"
                >
                  <div
                    class="c-dp-search__list-item search-ineligible auto-country-item"
                  >
                    <svg class="a-icon c-dp-search__list-item-icon">
                      <use xlink:href="#country"></use>
                    </svg>
                    <div class="m-info-set c-dp-search__list-item-main">
                      <span class="s4 ts-strong">{{
                        item.name | surfTextCase : "title"
                      }}</span>
                    </div>
                    <span class="c-dp-search__list-item-sub s5 ts-muted ts-wet"
                      >Country</span
                    >
                  </div>
                </surf-type-ahead-item>
              </surf-type-ahead-content>
            </surf-type-ahead>
            <span
              *ngIf="
                typeAheadService.getTypeAheadByType('country')
                  ?.searchInitialized &&
                typeAheadService.getTypeAheadByType('country')?.filteredList
                  .length == 0
              "
              style="color: red"
              >No results found</span
            >
          </div>

          
          <div class="c-dp-search__form-item">
            <surf-type-ahead
              [label]="'City'"
              [selectedItem]="
                typeAheadService.getTypeAheadByType('city')?.selected
              "
              [dataList]="cities"
              [mappings]="['code', 'value']"
              [paramName]="'ontotext'"
              [placeholder]="
                typeAheadService.getTypeAheadByType('city').placeholderText
              "
              [url]="typeAheadService.getTypeAheadByType('city').URL"
              [bindFocusOut]="false"
              [selectAllOnEnter]="false"
              [minQueryLengthToProceed]="MIN_SEARCH_QUERY_LENGTH"
              [isOnto]="true"
              [autoFocus]="false"
              [error]="false"
              [showErrorMsg]="true"
              (returnedQuery)="returnedSearchQueryForType($event, 'city')"
              (returnedData)="returnedValues($event, 'city')"
              (onClickOutside)="onClickOutside('city')"
              [tabIndex]="2"
              >
              <surf-type-ahead-content
                [typeAheadData]="
                  typeAheadService.getTypeAheadByType('city').filteredList
                "
                [available]="
                  typeAheadService.getTypeAheadByType('city').filteredList
                    .length > 0
                "
                (setItem)="selectCity($event, 'city')"
              >
                <surf-type-ahead-item
                  *ngFor="
                    let item of typeAheadService.getTypeAheadByType('city')
                      .filteredList;
                    let i = index
                  "
                  (click)="selectCity(item, 'city')"
                >
                  <div class="c-dp-search__list-item auto-city-item">
                    <svg class="a-icon c-dp-search__list-item-icon">
                      <use
                        *ngIf="item?.type == 'CITY' || item?.type == 40"
                        xlink:href="#map"
                      ></use>
                    </svg>
                    <div
                      class="m-info-set c-dp-search__list-item-main auto-destinations-list"
                    >
                      <span *ngIf="item?.name" class="s4 ts-strong">{{
                        item?.type === 40 || item?.type === 'CITY'
                          ? item?.name
                          : (item?.name
                            | surfTextCase : "title"
                            | surfShowCountryPipe)
                      }}</span>
                      <span class="s5 ts-muted ts-wet">
                        <span *ngIf="surfCriteriaUtil.getState(item)">{{
                          surfCriteriaUtil.getState(item) +
                            (surfCriteriaUtil.getCountry(item) ? ", " : "")
                        }}</span>
                        {{
                          surfCriteriaUtil.getCountry(item)
                            ? surfCriteriaUtil.getCountry(item)
                            : ""
                        }}
                      </span>
                    </div>
                    <span class="c-dp-search__list-item-sub s5 ts-muted ts-wet"
                      >City</span
                    >
                  </div>
                </surf-type-ahead-item>
              </surf-type-ahead-content>
            </surf-type-ahead>
            <span
              *ngIf="
                typeAheadService.getTypeAheadByType('city')
                  ?.searchInitialized &&
                typeAheadService.getTypeAheadByType('city')?.filteredList
                  .length == 0
              "
              style="color: red"
              >No results found</span
            >
          </div>

          <div
          class="c-dp-search__form-item"
          id="{{ windowScrollEnable ? 'scroll' : '' }}"
        >
          <!-- Hotel -->
          <div
            class="m-form-item auto-destination-input"
            (click)="scrollTo('#scroll')"
          >
            <surf-type-ahead
              [label]="'Hotel'"
              [dataList]="formHandlerService._hotels"
              [filterType]="'strict'"
              [mappings]="['code', 'value']"
              [sortOrder]="'A2Z'"
              [selectedItem]="
                typeAheadService.getTypeAheadByType('hotel').selected
              "
              [paramName]="'ontotext'"
              [placeholder]="
                typeAheadService.getTypeAheadByType('hotel').placeholderText
              "
              [bindFocusOut]="false"
              [selectAllOnEnter]="false"
              [isOnto]="true"
              [autoFocus]="true"
              [url]="typeAheadService.getTypeAheadByType('hotel').URL"
              [focusInput]="focusInit"
              [warningStyle]="'is-visited'"
              [minQueryLengthToProceed]="MIN_SEARCH_QUERY_LENGTH"
              (returnedQuery)="returnedSearchQueryForType($event, 'hotel')"
              (returnedData)="returnedValues($event, 'hotel')"
              (onClickOutside)="onClickOutside('hotel')"
              [tabIndex]="3"
            >
              <surf-type-ahead-content
                [typeAheadData]="
                  typeAheadService.getTypeAheadByType('hotel').filteredList
                "
                [available]="
                  typeAheadService.getTypeAheadByType('hotel').filteredList
                    ?.length > 0
                "
                [enableKeyStrokeIgnore]="true"
                (setItem)="selectHotel($event, 'hotel')"
              >
                <ng-container
                  *ngFor="
                    let item of typeAheadService.getTypeAheadByType('hotel')
                      .filteredList;
                    let i = index
                  "
                >
                  <surf-type-ahead-item
                    (click)="selectHotel(item, 'hotel')"
                  >
                    <div
                      class="c-dp-search__list-item search-ineligible auto-country-item"
                    >
                      <svg class="a-icon c-dp-search__list-item-icon">
                        <use
                          *ngIf="item?.type == 'HOTEL' || item?.type == 80"
                          xlink:href="#products--hotel"
                        ></use>
                      </svg>
                      <div
                        class="m-info-set c-dp-search__list-item-main auto-destinations-list"
                      >
                        <span class="s4 ts-strong">{{
                          item?.name | surfTextCase : "title"
                        }}</span>
                        <span class="s5 ts-muted ts-wet">
                          {{
                            item?.type == 80 &&
                            surfCriteriaUtil.getCity(item)?.name
                              ? surfCriteriaUtil.getCity(item)?.name +
                                (surfCriteriaUtil.getState(item) ? ", " : "")
                              : ""
                          }}
                          <span *ngIf="surfCriteriaUtil.getState(item)">{{
                            surfCriteriaUtil.getState(item) +
                              (surfCriteriaUtil.getCountry(item) ? ", " : "")
                          }}</span>
                          {{
                            surfCriteriaUtil.getCountry(item)
                              ? surfCriteriaUtil.getCountry(item)
                              : ""
                          }}
                        </span>
                      </div>
                      <span
                        *ngIf="item?.type == 'HOTEL' || item?.type == 80"
                        class="c-dp-search__list-item-sub s5 ts-muted ts-wet"
                        >Hotel</span
                      >
                    </div>
                  </surf-type-ahead-item>
                </ng-container>
              </surf-type-ahead-content>
            </surf-type-ahead>
            <span
              *ngIf="
                typeAheadService.getTypeAheadByType('hotel')
                  .searchInitialized &&
                typeAheadService.getTypeAheadByType('hotel').filteredList
                  .length == 0
              "
              style="color: red"
              >No results found</span
            >
          </div>
        </div>

          <div class="c-dp-search__form-item">
            <!-- Tariff Year -->
            <div class="m-form-item__input">
              <surf-ul-drop-down
                [label]="'Tariff Year*'"
                [placeholder]="'Tariff Year'"
                [items]="tariffYears"
                [native]="true"
                [select]="true"
                [firstDisplay]=""
                (singleObject)="selectTariffYear($event)"
                tabindex="4"
              >
              </surf-ul-drop-down>
            </div>
          </div>
          <div class="c-dp-search__form-item">
            <!-- From Date -->
            <div class="c-dp-search__form-item auto-pickup-datepicker">
              <surf-date-picker
                (click)="scrollTo('#scroll')"
                [single_calendar]="true"
                [inputLabel]="'From Date*'"
                [check_availability]="false"
                [calendar_start_date]="null"
                [enablePreviousDates]="true"
                [currentDateOfTimeZone]="calendarMinDate"
                [isError]="isInvalidTime"
                [invalidErrorMsg]="'Invalid'"
                [hideErrorMsg]="hideErrorMsgPickUp"
                [validateDisabledDateSelection]="false"
                [reset]="resetPickupCalendar"
                [isFocused]="datePickerFocus"
                (selected_dates)="getSelectedDateTime($event, true)"
                [initial_dates]="pickUpInitialDate"
                [timeInputs]="false"
                [warningStyle]="'is-visited'"
                [warning1]="pickupDateWarning"
                [tabIndex]="5"
              ></surf-date-picker>
            </div>
          </div>
          <div class="c-dp-search__form-item auto-pickup-datepicker">
            <!-- To Date -->
            <div
              class="c-dp-search__form-item c-dp-search__form-item--inverted auto-dropOff-datepicker"
            >
              <surf-date-picker
                (click)="scrollTo('#scroll')"
                [single_calendar]="true"
                [inputLabel]="'To Date*'"
                [check_availability]="false"
                [reset]="resetReturnCalendar"
                [calendarStartDate]="selectedPickupDate"
                [initial_dates]="returnInitialDate"
                [isError]="isInvalidTime"
                [invalidErrorMsg]="'Invalid'"
                [hideErrorMsg]="hideErrorMsgReturn"
                (selected_dates)="getSelectedDateTime($event, false)"
                [timeEnable]="false"
                [timeInputs]="false"
                [warningStyle]="'is-visited'"
                [warning1]="returnDateWarning"
                [enablePreviousDates]="true"
                [currentDateOfTimeZone]="
                  selectedPickupDate ? selectedPickupDate : calendarMinDate
                "
                [tabIndex]="6"
              ></surf-date-picker>
              <span
                *ngIf="isInvalidTime"
                class="m-form-field__error has-error"
                style="display: block !important"
                >Please enter valid return date & time</span
              >
            </div>
          </div>
          <div class="c-dp-search__form-item">
            <!-- Currency -->
            <surf-ul-drop-down
              [label]="'Currency*'"
              [items]="currencies"
              [firstDisplay]=""
              [select]="true"
              [native]="true"
              (singleObject)="selectCurrency($event)"
              [warningStyle]="'is-visited'"
              [tabIndex]="7"
              [disabled]="true"
            >
            </surf-ul-drop-down>
          </div>
        </div>
      </div>

      <div class="c-advance-search__btn-wrapper">
        <div class="c-advance-search__search-action">
          <ng-container>
            <button
              class="a-btn a-btn--default auto-reset-btn"
              (click)="resetAllInputs()"
              [tabIndex]="8"
            >
              Reset Search
            </button>
          </ng-container>
          <button
            class="a-btn a-btn--primary auto-search-btn"
            (click)="searchTariffs()"
            [tabIndex]="9"
            [ngClass]="{ 'is-disabled': !validateInputs() }"
          >
            Search
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
